import { useContext } from "react";
import FormContext from "../context/FormContext";

const useGetPrice: () => {
  lastPrice: number;
  tempPrice: number;
  percentage: number;
} = () => {
  const { formData } = useContext(FormContext);

  // Porcentaje por tecnologias
  const techPrices = (price: number) => {
    if (formData?.projectTechs) {
      formData?.projectTechs.forEach((element: string) => {
        if (element.includes("React")) {
          price += 10;
        }
        if (element.includes("Laravel")) {
          price += 5;
        }
        if (element.includes("Wordpress")) {
          price += 2;
        }
      });
    }
    return price;
  };

  // Prioridad
  const timePerWork = (mode: string) => {
    let value = 0;

    if (mode === "High") {
      value += 6;
    } else {
      if (mode === "Medium") {
        value += 4;
      } else {
        if (mode === "Low") {
          value += 2;
        }
      }
    }
    return value;
  };

  // Horas
  const hours: number = formData?.projectTime || 0;

  // Horas por prioridad
  const tempPrice: number =
    hours * timePerWork(formData?.projectLevel || "High");
  // Porcentaje
  const percentage = (tempPrice * techPrices(1)) / 100;

  const tempFinalPrice = tempPrice + percentage;

  // Precio Final
  const finalPrice = (price: number) => {
    let final = 1;

    if (formData?.clientCountry === "Estados Unidos") {
      const finalPercentage = (price * 20) / 100;
      final = price + finalPercentage;
    } else {
      final = price;
    }
    return final;
  };

  const lastPrice = finalPrice(tempFinalPrice);

  return { lastPrice, tempPrice, percentage };
};

export default useGetPrice;
